import React, { useState, useEffect, useRef } from "react";
import api from "@/services/api";
import get from "lodash/get";
import "./form.scss";

const NeighborOrganizations = ({ isOpen, regionId, districtId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const prevParamsRef = useRef(null);

  useEffect(() => {
    if (!isOpen || !regionId || !districtId) {
      setItems([]);
      setFetched(false);
      return;
    }

    const key = `${regionId}-${districtId}`;
    if (prevParamsRef.current === key && fetched) return;
    prevParamsRef.current = key;

    setLoading(true);
    setFetched(false);

    api
      .request({
        method: "get",
        url: "/employee/leads/get-neighboard-organizations",
        params: {
          region_id: regionId,
          district_id: districtId,
        },
      })
      .then((res) => {
        const data =
          get(res, "data.data") ||
          get(res, "data") ||
          [];
        setItems(Array.isArray(data) ? data : []);
      })
      .catch(() => setItems([]))
      .finally(() => {
        setLoading(false);
        setFetched(true);
      });
  }, [isOpen, regionId, districtId]);

  if (!isOpen) return null;

  
  if (!regionId || !districtId) {
    return (
      <div className="nb-alert nb-alert--warn">
        <svg className="nb-alert__icon" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <span>Чтобы увидеть соседние организации, сначала выберите <strong>регион</strong> и <strong>район</strong></span>
      </div>
    );
  }

  
  if (loading) {
    return (
      <div className="nb-skeleton-wrap">
        {[1, 2, 3].map((i) => (
          <div key={i} className="nb-skeleton-row">
            <div className="nb-skeleton-dot" />
            <div className="nb-skeleton-text" style={{ width: i === 2 ? "55%" : i === 3 ? "70%" : "80%" }} />
            <div className="nb-skeleton-badge" />
          </div>
        ))}
      </div>
    );
  }

  
  if (fetched && items.length === 0) {
    return (
      <div className="nb-alert nb-alert--empty">
        <svg className="nb-alert__icon" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm3 1h6v4H7V5zm8 8v2h1v1H4v-1h1v-2a1 1 0 011-1h8a1 1 0 011 1z" clipRule="evenodd" />
        </svg>
        <span>Соседних организаций в данном районе не найдено</span>
      </div>
    );
  }

  
  return (
    <div className="nb-wrap">
      <div className="nb-header">
        <span className="nb-header__title">
          <span className="nb-header__dot" />
          Соседние организации
        </span>
        <span className="nb-header__count">{items.length}</span>
      </div>

      <div className="nb-list">
        {items.map((item, index) => {
          const name = get(item, "name") || "—";
          const paymentId = get(item, "payment_id");
          const initials = name
            .split(" ")
            .slice(0, 2)
            .map((w) => w[0])
            .join("")
            .toUpperCase();
          const colors = [
            "#6366f1","#8b5cf6","#ec4899","#f59e0b","#10b981","#3b82f6","#ef4444","#14b8a6",
          ];
          const color = colors[index % colors.length];

          return (
            <div key={paymentId || index} className="nb-card">
              <div className="nb-card__avatar" style={{ background: color + "22", color }}>
                {initials}
              </div>
              <div className="nb-card__info">
                <span className="nb-card__name">{name}</span>
                {paymentId && (
                  <span className="nb-card__id">ID: {paymentId}</span>
                )}
              </div>
              <div className="nb-card__num">#{index + 1}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NeighborOrganizations;
